import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { COUNTRIES } from '@frontend/addresses';
import { Select, type SelectProps } from '@frontend/legacy-components';

import { getDefaultFacilityCountry } from 'store/session/selectors';

export type CountryData = {
  name: string;
  abbreviation: string;
};

export type CountrySelectProps = Omit<SelectProps, 'value'> & {
  value?: string; // country abbreviation
};

export const CountrySelect = ({ value, ...props }: CountrySelectProps) => {
  const countryOptions = useMemo(() => {
    return (COUNTRIES as CountryData[]).map(({ abbreviation, name }) => ({
      label: name,
      value: abbreviation,
    }));
  }, []);

  const defaultCountry = useSelector(getDefaultFacilityCountry);

  return (
    <Select
      isClearable={false}
      placeholder=""
      options={countryOptions}
      value={countryOptions.find((c) => c.value === value)}
      defaultValue={countryOptions.find((c) => c.value === defaultCountry)}
      {...props}
    />
  );
};
